import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Amplify, I18n } from "aws-amplify";
import config from "./config";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import CustomSignIn from "./CustomSignIn";
import { translations } from '@aws-amplify/ui-react';
import { Helmet } from "react-helmet";



I18n.putVocabularies(translations);
I18n.setLanguage('nl');

I18n.putVocabularies({
  fr: {
    'Sign In': 'Se connecter',
    'Sign Up': "S'inscrire",
  },
  es: {
    'Sign In': 'Registrarse',
    'Sign Up': 'Regístrate',
  },
});
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: "FRONTEND_HTTP_API",
        endpoint: config.apiGateway.REACT_APP_API_URL,
        region: config.apiGateway.REGION,
      },
      //{
      //  name: "PythonApi",
      //  endpoint: config.apiGateway.URL2,
      //     //  region: config.apiGateway.REGION,
      //      //},
      //      //{
      //      //  name: "RApi",
      //  endpoint: config.apiGateway.//3,
      //  region: config.apiGateway.REGION,
      //},
      //{
      //  name: "notes2",
      //  endpoint: config.apiGateway.URL,
      //  region: config.apiGateway.REGION,
      //},
    ],
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));



// WRAP APP with <Authenticator> for authentication STIJN
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Helmet>
        {/* Google tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-QRLVQ3M1WM"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-QRLVQ3M1WM', {
              'linker': {'domains': ['memochill.be', 'my.memochill.be']}
              });
          `}
        </script>
        {/* Event snippet for Page view conversion page */}
        <script>
          {`
            gtag('event', 'conversion', {
                'send_to': 'AW-16766635265/Mv_rCKq_i-YZEIGa-ro-',
                'value': 1.0,
                'currency': 'EUR'
            });
          `}
        </script>
      </Helmet>
      <Authenticator
        //socialProviders={["google", "facebook", "amazon", "apple"]}
        hideSignUp={false}
        components={{
          SignIn: CustomSignIn,
        }}
      >
        <App gitRevision={config.meta.VERSION} stage={config.meta.STAGE} />
      </Authenticator>
    </BrowserRouter>
  </React.StrictMode>
);
